'use strict';
const RestUtils = require('utils/RestUtils'),
    Security = require('./Security').auth,
    Constants = require('constants/AppConstants'),
    SessionStore = require('stores/SessionStore');

const ChronologycService = {

    fetchBrewingNotes: function (success, failure) {
        var ajax = RestUtils.createXHR();

        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('GET', process.env.URL_API + '/notes/' + SessionStore.getCurrentApplicant() + '/type/' + Constants.NOTE_TYPE_BREWING, true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader('X-AUTH-TOKEN', Security.getToken());
        ajax.send();
    },

    fetchPackagingNotes: function (success, failure) {
        var ajax = RestUtils.createXHR();

        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('GET', process.env.URL_API + '/notes/' + SessionStore.getCurrentApplicant() + '/type/' + Constants.NOTE_TYPE_PACKAGING, true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader('X-AUTH-TOKEN', Security.getToken());
        ajax.send();
    }
};


module.exports = ChronologycService;



/** WEBPACK FOOTER **
 ** ./src/services/ChronologycServiceImpl.js
 **/